<template>
    <div>
        <v-header :seller="seller" :is-seft="0"></v-header>

        <v-goods :seller="seller" :is-seft="0"  :is-seft-pay="0"></v-goods>
    </div>
</template>

<script>
    import header from '../components/Header';
    import goods from '../components/Goods';
    import sellerInfo from '../components/Seller';

    export default {
        inject: ['reload'],
        data() {
            return {
                active1: 0,
                seller: {},
                tableOrderInfo: {},
            }
        },
        created() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        },
        methods: {
        
        },
        components: {
            'v-header': header,
            'v-goods': goods,
            'v-seller': sellerInfo
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/Restaurant.vue